module.exports = __webpack_public_path__ + "img/roadmap-cat.04bf26c6.png";